import { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  en: {
    // Booking Calendar
    reserveYour: 'Reserve Your',
    dayPass: 'Day Pass',
    heroSubtitle: 'Select a time \u00B7 Pay securely \u00B7 Arrive & unwind',
    dayPassLabel: 'Day Pass \u2014 Las Ruinas Bathhouse',
    dayPassPrice: '$68 \u00B7 $75.82 with tax',
    dayPassDesc: 'An 11,000 sqft sanctuary in the heart of Old San Juan. Your 2.5-hour pass includes unlimited access to thermal pools, cold plunge, swimming pool, dry sauna, infrared sauna, steam room, complimentary tea lounge, and fully equipped gym. Unlimited towels included.',
    dayPassNote: 'Flip-flops recommended \u00B7 Massages & smoothies available as add-ons \u00B7 No re-entry',
    noSlots: 'No time slots available for this date',
    soldOut: 'Sold out',
    lastSpot: 'Last spot',
    left: 'left',
    popular: 'Popular',
    guest: 'guest',
    guests: 'guests',
    guestsLabel: 'Guests',
    reserve: 'Reserve',
    // Footer
    footerCopy: '\u00A9 2026 Las Ruinas Bathhouse & Gym LLC \u00B7 Old San Juan, Puerto Rico',
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Terms & Conditions',
    paymentsSecuredBy: 'Payments secured by Stripe',
    // Checkout
    checkout: 'Checkout',
    orderSummary: 'Order Summary',
    serviceFee: 'Service Fee',
    tax: 'Tax',
    promo: 'Promo',
    total: 'Total',
    contact: 'Contact',
    fullName: 'Full Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    optional: 'optional',
    nameRequired: 'Name is required',
    emailRequired: 'Email is required',
    iAgree: 'I agree to the Las Ruinas',
    iPersonAgree: 'I, {name}, agree to the Las Ruinas',
    pleaseAgreeTerms: 'Please agree to the Terms & Conditions to continue',
    cancellationPolicy: 'Cancellation Policy',
    freeCancellation: 'Free cancellation up to 24 hours before your visit',
    noRefund24h: 'No refund within 24 hours of your visit',
    noRefundNoShow: 'No refund for no-shows',
    stripeNonRefundable: 'Stripe processing fee (~3%) is non-refundable on all cancellations. Prices are dynamic and may change based on demand. Your price is locked at time of booking.',
    promoCode: 'Promo Code',
    enterCode: 'Enter code',
    apply: 'Apply',
    off: 'off',
    payment: 'Payment',
    processing: 'Processing\u2026',
    pay: 'Pay',
    networkError: 'Network error. Please try again.',
    failedPayment: 'Failed to create payment',
    slotNoLongerAvailable: 'Slot is no longer available. Your payment will be refunded automatically.',
    networkErrorBooking: 'Network error saving your booking. Your payment was successful \u2014 please contact us at Frontdesk@lasruinas.com with ref: ',
    // What's Included
    dayPassTitle: 'Day Pass \u2014 Las Ruinas Bathhouse',
    thermalExperience: 'Your 2.5-hour thermal experience includes:',
    incThermal: 'Thermal pools, cold plunge, hot plunge, swimming pool',
    incSauna: 'Dry sauna, infrared sauna, steam room',
    incTea: 'Complimentary tea lounge',
    incGym: 'Fully equipped gym',
    incTowels: 'Unlimited towels',
    incNote: 'Flip-flops recommended. Massages & smoothies available as add-ons.',
    // Success
    youreConfirmed: "You're confirmed!",
    dayPassBooked: 'Your day pass is booked and ready.',
    sendingEmail: 'Sending confirmation email...',
    emailSent: 'Confirmation email sent',
    emailFailed: 'Email could not be sent',
    viewMyBooking: 'VIEW MY BOOKING',
    // Urgency
    lastAvailableSpot: 'This is the last available spot',
    onlyXSpotsLeft: 'Only {{spots}} spots left',
    onlyXSpotsBook: 'Only {{spots}} spots left \u2014 book now',
    popularSlot: 'One of our most popular time slots',
    // 404
    pageNotFound: 'Page not found',
    pageNotFoundDesc: "The page you're looking for doesn't exist or may have been moved.",
    backToLasRuinas: 'Back to Las Ruinas',
    // Confirmation Page
    confirmationLoading: 'Loading...',
    bookingNotFound: 'Booking not found',
    unableToLoad: 'Unable to load booking. Please check your connection.',
    yourBooking: 'Your Booking',
    bookingConfirmation: 'Booking Confirmation',
    bookingRef: 'Booking Reference',
    date: 'Date',
    time: 'Time',
    amountPaid: 'Amount Paid',
    showQR: 'Show this QR code at the front desk for quick check-in.',
    needToChange: 'Need to change your plans?',
    rescheduleOrCancel: 'RESCHEDULE OR CANCEL',
    // Reschedule Page
    rescheduleBooking: 'Reschedule Your Booking',
    currentBooking: 'Current Booking',
    selectNewSlot: 'Select a new time',
    noAvailableSlots: 'No slots available for this date',
    priceDifference: 'Price Difference',
    samePrice: 'Same price \u2014 no extra charge',
    additionalCharge: 'Additional charge',
    confirmReschedule: 'CONFIRM RESCHEDULE',
    rescheduled: 'Booking Rescheduled!',
    rescheduledSuccess: 'Your booking has been moved to your new time.',
    cancelBooking: 'Cancel Booking',
    cancelConfirmation: 'Are you sure you want to cancel?',
    cancelWarning: 'Cancellations within 24 hours are non-refundable.',
    refundNote: 'A refund (minus Stripe processing fee) will be issued within 5-10 business days.',
    yesCancel: 'YES, CANCEL MY BOOKING',
    neverMind: 'Never mind',
    bookingCancelled: 'Booking Cancelled',
    refundIssued: 'refund will be processed within 5-10 business days.',
    bookNewVisit: 'BOOK A NEW VISIT',
    goToBooking: 'GO TO BOOKING',
    ticketLabel: 'Day Pass',
    // Confirmation Page extras
    guestLabel: 'Guest',
    dateTime: 'Date & Time',
    paymentLabel: 'Payment',
    paid: 'PAID',
    refunded: 'REFUNDED',
    pending: 'PENDING',
    getDirections: 'Get Directions',
    addToCalendar: 'Add to Google Calendar',
    rescheduleOrCancelAction: 'Reschedule or Cancel',
    questions: 'Questions?',
    tipTitle: 'Tip:',
    tipText: 'Add this page to your home screen for easy access on arrival',
    // Language
    langEN: 'EN',
    langES: 'ES',
  },
  es: {
    // Booking Calendar
    reserveYour: 'Reserva Tu',
    dayPass: 'Pase del D\u00EDa',
    heroSubtitle: 'Elige un horario \u00B7 Paga seguro \u00B7 Llega y rel\u00E1jate',
    dayPassLabel: 'Pase de D\u00EDa \u2014 Las Ruinas Bathhouse',
    dayPassPrice: '$68 \u00B7 $75.82 con impuesto',
    dayPassDesc: 'Un santuario de 11,000 pies cuadrados en el coraz\u00F3n del Viejo San Juan. Tu pase de 2.5 horas incluye acceso ilimitado a piscinas termales, cold plunge, piscina, sauna seco, sauna infrarrojo, ba\u00F1o de vapor, sal\u00F3n de t\u00E9 gratuito y gimnasio completamente equipado. Toallas ilimitadas incluidas.',
    dayPassNote: 'Se recomiendan chancletas \u00B7 Masajes y smoothies disponibles como extras \u00B7 Sin reentrada',
    noSlots: 'No hay horarios disponibles para esta fecha',
    soldOut: 'Agotado',
    lastSpot: '\u00DAltimo lugar',
    left: 'disponibles',
    popular: 'Popular',
    guest: 'hu\u00E9sped',
    guests: 'hu\u00E9spedes',
    guestsLabel: 'Hu\u00E9spedes',
    reserve: 'Reservar',
    // Footer
    footerCopy: '\u00A9 2026 Las Ruinas Bathhouse & Gym LLC \u00B7 Viejo San Juan, Puerto Rico',
    privacyPolicy: 'Pol\u00EDtica de Privacidad',
    termsAndConditions: 'T\u00E9rminos y Condiciones',
    paymentsSecuredBy: 'Pagos seguros por Stripe',
    // Checkout
    checkout: 'Pago',
    orderSummary: 'Resumen del Pedido',
    serviceFee: 'Cargo por Servicio',
    tax: 'Impuesto',
    promo: 'Promoci\u00F3n',
    total: 'Total',
    contact: 'Contacto',
    fullName: 'Nombre Completo',
    email: 'Correo Electr\u00F3nico',
    phoneNumber: 'N\u00FAmero de Tel\u00E9fono',
    optional: 'opcional',
    nameRequired: 'El nombre es obligatorio',
    emailRequired: 'El correo es obligatorio',
    iAgree: 'Acepto los',
    iPersonAgree: 'Yo, {name}, acepto los',
    pleaseAgreeTerms: 'Debes aceptar los T\u00E9rminos y Condiciones para continuar',
    cancellationPolicy: 'Pol\u00EDtica de Cancelaci\u00F3n',
    freeCancellation: 'Cancelaci\u00F3n gratuita hasta 24 horas antes de tu visita',
    noRefund24h: 'Sin reembolso dentro de las 24 horas de tu visita',
    noRefundNoShow: 'Sin reembolso por inasistencia',
    stripeNonRefundable: 'La tarifa de procesamiento de Stripe (~3%) no es reembolsable. Los precios son din\u00E1micos y pueden cambiar seg\u00FAn la demanda. Tu precio se fija al momento de la reserva.',
    promoCode: 'C\u00F3digo Promocional',
    enterCode: 'Ingresa c\u00F3digo',
    apply: 'Aplicar',
    off: 'de descuento',
    payment: 'Pago',
    processing: 'Procesando\u2026',
    pay: 'Pagar',
    networkError: 'Error de red. Intenta de nuevo.',
    failedPayment: 'No se pudo crear el pago',
    slotNoLongerAvailable: 'El horario ya no est\u00E1 disponible. Tu pago ser\u00E1 reembolsado autom\u00E1ticamente.',
    networkErrorBooking: 'Error de red al guardar tu reserva. Tu pago fue exitoso \u2014 cont\u00E1ctanos en Frontdesk@lasruinas.com con ref: ',
    // What's Included
    dayPassTitle: 'Pase del D\u00EDa \u2014 Las Ruinas Bathhouse',
    thermalExperience: 'Tu experiencia termal de 2.5 horas incluye:',
    incThermal: 'Piscinas termales, plunge fr\u00EDo, plunge caliente, piscina',
    incSauna: 'Sauna seco, sauna infrarrojo, ba\u00F1o de vapor',
    incTea: 'Sal\u00F3n de t\u00E9 de cortes\u00EDa',
    incGym: 'Gimnasio totalmente equipado',
    incTowels: 'Toallas ilimitadas',
    incNote: 'Se recomiendan chancletas. Masajes y batidos disponibles como extras.',
    // Success
    youreConfirmed: '\u00A1Est\u00E1s confirmado!',
    dayPassBooked: 'Tu pase del d\u00EDa est\u00E1 reservado y listo.',
    sendingEmail: 'Enviando correo de confirmaci\u00F3n...',
    emailSent: 'Correo de confirmaci\u00F3n enviado',
    emailFailed: 'No se pudo enviar el correo',
    viewMyBooking: 'VER MI RESERVA',
    // Urgency
    lastAvailableSpot: 'Este es el \u00FAltimo lugar disponible',
    onlyXSpotsLeft: 'Solo quedan {{spots}} lugares',
    onlyXSpotsBook: 'Solo quedan {{spots}} lugares \u2014 reserva ahora',
    popularSlot: 'Uno de nuestros horarios m\u00E1s populares',
    // 404
    pageNotFound: 'P\u00E1gina no encontrada',
    pageNotFoundDesc: 'La p\u00E1gina que buscas no existe o fue movida.',
    backToLasRuinas: 'Volver a Las Ruinas',
    // Confirmation Page
    confirmationLoading: 'Cargando...',
    bookingNotFound: 'Reserva no encontrada',
    unableToLoad: 'No se pudo cargar la reserva. Verifica tu conexi\u00F3n.',
    yourBooking: 'Tu Reserva',
    bookingConfirmation: 'Confirmaci\u00F3n de Reserva',
    bookingRef: 'Referencia de Reserva',
    date: 'Fecha',
    time: 'Hora',
    amountPaid: 'Monto Pagado',
    showQR: 'Muestra este c\u00F3digo QR en la recepci\u00F3n para un check-in r\u00E1pido.',
    needToChange: '\u00BFNecesitas cambiar tus planes?',
    rescheduleOrCancel: 'REAGENDAR O CANCELAR',
    // Reschedule Page
    rescheduleBooking: 'Reagendar Tu Reserva',
    currentBooking: 'Reserva Actual',
    selectNewSlot: 'Selecciona un nuevo horario',
    noAvailableSlots: 'No hay horarios disponibles para esta fecha',
    priceDifference: 'Diferencia de Precio',
    samePrice: 'Mismo precio \u2014 sin cargo extra',
    additionalCharge: 'Cargo adicional',
    confirmReschedule: 'CONFIRMAR REAGENDAMIENTO',
    rescheduled: '\u00A1Reserva Reagendada!',
    rescheduledSuccess: 'Tu reserva fue movida a tu nuevo horario.',
    cancelBooking: 'Cancelar Reserva',
    cancelConfirmation: '\u00BFEst\u00E1s seguro de que quieres cancelar?',
    cancelWarning: 'Las cancelaciones dentro de 24 horas no son reembolsables.',
    refundNote: 'El reembolso (menos la tarifa de procesamiento de Stripe) se emitir\u00E1 en 5-10 d\u00EDas h\u00E1biles.',
    yesCancel: 'S\u00CD, CANCELAR MI RESERVA',
    neverMind: 'No importa',
    bookingCancelled: 'Reserva Cancelada',
    refundIssued: 'el reembolso se procesar\u00E1 en 5-10 d\u00EDas h\u00E1biles.',
    bookNewVisit: 'RESERVAR UNA NUEVA VISITA',
    goToBooking: 'IR A LA RESERVA',
    ticketLabel: 'Pase del Día',
    // Confirmation Page extras
    guestLabel: 'Huésped',
    dateTime: 'Fecha y Hora',
    paymentLabel: 'Pago',
    paid: 'PAGADO',
    refunded: 'REEMBOLSADO',
    pending: 'PENDIENTE',
    getDirections: 'Cómo Llegar',
    addToCalendar: 'Agregar a Google Calendar',
    rescheduleOrCancelAction: 'Reagendar o Cancelar',
    questions: '¿Preguntas?',
    tipTitle: 'Consejo:',
    tipText: 'Agrega esta página a tu pantalla de inicio para acceso rápido al llegar',
    // Language
    langEN: 'EN',
    langES: 'ES',
  },
};

const LangContext = createContext({ lang: 'en', t: (k) => k, setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem('lr_lang');
      if (saved) return saved;
      const detected = (navigator.language || '').startsWith('es') ? 'es' : 'en';
      localStorage.setItem('lr_lang', detected);
      return detected;
    } catch { return 'en'; }
  });

  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem('lr_lang', l); } catch {}
  }, []);

  const t = useCallback((key, replacements) => {
    let str = (translations[lang] && translations[lang][key]) || translations.en[key] || key;
    if (replacements) {
      Object.entries(replacements).forEach(([k, v]) => {
        str = str.replace(`{${k}}`, v).replace(`{{${k}}}`, v);
      });
    }
    return str;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}

export function LanguageToggle() {
  const { lang, setLang } = useLang();
  return (
    <div className="lr-lang-toggle" data-testid="language-toggle">
      <button
        className={`lr-lang-btn${lang === 'en' ? ' active' : ''}`}
        data-testid="lang-en"
        onClick={() => setLang('en')}
      >EN</button>
      <button
        className={`lr-lang-btn${lang === 'es' ? ' active' : ''}`}
        data-testid="lang-es"
        onClick={() => setLang('es')}
      >ES</button>
    </div>
  );
}
